import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, UntypedFormGroup, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-property-damage-detail',
    templateUrl: './property-damage-detail.component.html',
    styleUrls: ['./property-damage-detail.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatCheckboxModule,
        MatButtonModule,
        MatExpansionModule,
        MatIconModule
    ]
})
export class PropertyDamageDetailComponent implements OnInit {
  form: UntypedFormGroup;

  constructor(private readonly fb: UntypedFormBuilder) {}
  ngOnInit(): void {
    //this.form = this.createForm();
    this.form = this.fb.group({
      propertyDamages: this.fb.array([this.createPropertyDamage()])
    });
  }

  // createForm(): FormGroup {
  //   return this.fb.group({
  //     propertyDesc: [''],
  //     driverNameAddress: [''],
  //     driverPhone: [''],
  //     driverLicense: [''],
  //     driverInsuranceNumber: [''],
  //     damageDesc: [''],
  //   });
  // }

  get propertyDamages(): UntypedFormArray {
    return this.form.get('propertyDamages') as UntypedFormArray;
  }

  createPropertyDamage(): UntypedFormGroup {
    return this.fb.group({
      propertyDesc: [''],
      driverNameAddress: [''],
      driverPhone: [''],
      driverLicense: [''],
      driverInsuranceNumber: [''],
      damageDesc: ['']
    });
  }

  addPropertyDamage(): void {
    this.propertyDamages.push(this.createPropertyDamage());
  }

  removePropertyDamage(index: number): void {
    if (this.propertyDamages.length > 1) {
      this.propertyDamages.removeAt(index);
    }
  }
}
